import React from 'react'

interface HabitsIconProps {
  size?: number
  className?: string
}

export const HabitsIcon: React.FC<HabitsIconProps> = ({ size = 17, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.67 0.66L8.67 3.66H5.17C2.68 3.66 0.67 5.68 0.67 8.16C0.67 10.65 2.68 12.66 5.17 12.66"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.66 15.66L7.67 12.66H11.16C13.65 12.66 15.66 10.65 15.66 8.16C15.66 5.68 13.65 3.66 11.16 3.66"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
